'use client';

import { useLinkStatus } from 'next/link';
import { useRotuloCargando } from '@/components/layout/PageLoading';

/**
 * La flecha de una opción del menú, que se convierte en spinner mientras esa
 * navegación está en curso.
 *
 * Por qué no alcanza con el `loading.tsx` de la ruta: esa frontera se pinta
 * recién cuando el router resolvió el destino, y eso cuesta un viaje a la red
 * (medido: ~300ms en 4G, más en 3G). `useLinkStatus` en cambio se pone en
 * `pending` en el mismo frame del toque, sin pedirle nada a nadie. Son dos
 * señales encadenadas y las dos hacen falta: ésta responde al dedo, la otra
 * sostiene la espera una vez que la pantalla cambió.
 *
 * Tiene que vivir en su propio componente porque `useLinkStatus` sólo funciona
 * dentro de un `<Link>` de Next.
 */
export default function IndicadorDeNavegacion({
  opacidad = 0.4,
  /** Para el botón de CTA, que no lleva flecha: o hay spinner, o no hay nada. */
  soloMientrasCarga = false,
}: { opacidad?: number; soloMientrasCarga?: boolean }) {
  const { pending } = useLinkStatus();
  const rotulo = useRotuloCargando();

  if (pending) {
    return (
      <span
        className="h-[18px] w-[18px] rounded-full border-2 border-current border-t-transparent animate-spin"
        role="status"
        aria-label={rotulo}
      />
    );
  }

  if (soloMientrasCarga) return null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ opacity: opacidad }}
      aria-hidden="true"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}
